import React, { useEffect } from "react";
import "../styles/blog.css";
import "../styles/home.css";
import Teamwork from "../assets/images/Teamwork.png";
import AvatarPlaceholder from "../assets/images/AvatarPlaceholder.png";
import Amalgam from "../assets/images/Amalgam-logo.png";
import AvatarPlaceholder2 from "../assets/images/Placeholder2.png";
import Blog1 from "../assets/images/blog-images/Blog1.png";
import Blog2 from "../assets/images/blog-images/Blog2.png";
import Blog3 from "../assets/images/blog-images/Blog3.png";
import Blog4 from "../assets/images/blog-images/Blog4.png";
import Blog5 from "../assets/images/blog-images/Blog5.png";
import Blog6 from "../assets/images/blog-images/Blog6.png";
import Blog7 from "../assets/images/blog-images/Blog7.png";
import Blog8 from "../assets/images/blog-images/M&TBank.png";
// import Facebook from '../assets/images/Facebook.png'
// import Instagram from '../assets/images/Instagram.png'
// import X from '../assets/images/X.png'
import LinkedIn from "../assets/images/LinkedIn.png";
// import Youtube from '../assets/images/Youtube.png'
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import Arrow from "../assets/images/Arrow1.png";
import { useNavigate } from "react-router-dom";

function Blog() {
  const isMobile = useMediaQuery({ maxWidth: 570 });
  const isTablet = useMediaQuery({ maxWidth: 1100 });
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top
  }, [pathname]);
  return (
    <div style={{ position: "relative", zIndex: 1, backgroundColor: "white" }}>
      <div className="blog-layout">
        <section className="blog-row-1">
          <h1>
            Learn more about what <br className="blog-row-1-break" /> drives
            your growth
          </h1>
          <p>
            Explore our content on entrepreneurship,{" "}
            <br className="blog-row-1-break" /> business, technology, and
            funding.
          </p>
        </section>

        <section className="blog-row-3">
          <div className="blog-row-3-articles">
            <div className="blog-row-3-article-row">
              <div className="blog-row-3-card">
                <Link
                  to="/case-studies/pfa"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <img
                    src={Blog1}
                    alt="Placeholder"
                    className="blog-card-image"
                  />
                  <div className="blog-row-3-article-info">
                    <article>Insurance</article>
                    <article id="PFA-blog-title" className="blog-title">
                      Premier Financial Alliance
                    </article>
                    <article className="blog-description">
                      How We Streamlined Premier Financial Alliance's Employee
                      Operations
                    </article>
                  </div>
                </Link>
              </div>
              <div className="blog-row-3-card">
                <Link
                  to="/case-studies/pearlx"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <img src={Blog2} alt="Placeholder" />
                  <div className="blog-row-3-article-info">
                    <article>Energy</article>
                    <article>PearlX</article>
                    <article>
                      How We Built PearlX's State Of The Art Customer Portal
                    </article>
                  </div>
                </Link>
              </div>
              <div className="blog-row-3-card">
                <Link
                  to="/case-studies/barclays"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <img src={Blog3} alt="Placeholder" />
                  <div className="blog-row-3-article-info">
                    <article>Banking</article>
                    <article>Barclays Bank US</article>
                    <article>
                      {" "}
                      Website Revamp And CMS We Implemented Enabled Barclay's to
                      Cater to its Diverse Customers
                    </article>
                  </div>
                </Link>
              </div>
            </div>
            <div className="blog-row-3-article-row">
              <div className="blog-row-3-card">
                <Link
                  to="/case-studies/adminpartners"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <img src={Blog4} alt="Placeholder" />
                  <div className="blog-row-3-article-info">
                    <article>Retirement/Financial Services</article>
                    <article>Admin Partners</article>
                    <article>
                      How We Upgraded A Client's Core System and Boosted Their
                      Operational Efficiency
                    </article>
                  </div>
                </Link>
              </div>
              <div className="blog-row-3-card">
                <Link
                  to="/case-studies/jtf"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <img src={Blog5} alt="Placeholder" />
                  <div className="blog-row-3-article-info">
                    <article>Philanthropy</article>
                    <article>John Templeton Foundation</article>
                    <article>
                      How We Improved JTF's Grant Classification and Trend
                      Analysis Using Artificial Intelligence
                    </article>
                  </div>
                </Link>
              </div>
              <div className="blog-row-3-card">
                <Link
                  to="/case-studies/cleanitsupply"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <img src={Blog6} alt="Placeholder" />
                  <div className="blog-row-3-article-info">
                    <article>Retail</article>
                    <article>CleanItSupply</article>
                    <article>
                      Optimizing CleanItSupply's Website for The Best Efficiency
                      and User Experience{" "}
                    </article>
                  </div>
                </Link>
              </div>
            </div>
            <div className="blog-row-3-article-row">
              <div className="blog-row-3-card">
                <Link
                  to="/case-studies/constructive"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <img src={Blog7} alt="Placeholder" />
                  <div className="blog-row-3-article-info">
                    <article>Procurement & Utility Solutions</article>
                    <article>Constructive Built Environment</article>
                    <article>
                      How We Helped Constructive Built Environment Build the
                      CART Platform
                    </article>
                  </div>
                </Link>
              </div>
              <div className="blog-row-3-card">
                <Link
                  to="/case-studies/mtbank"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <img src={Blog8} alt="Placeholder" />
                  <div className="blog-row-3-article-info">
                    <article>Financial Services</article>
                    <article>M&T Bank</article>
                    <article>How We Helped M&T Bank Navigate a Complex Legacy System Modernization</article>
                  </div>
                </Link>
              </div>
              <div className="blog-row-3-card">
                {/* <Link
                  to="/case-studies/constructive"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <img src={Blog7} alt="Placeholder" />
                  <div className="blog-row-3-article-info">
                    <article>Procurement & Utility Solutions</article>
                    <article>Constructive Built Environment</article>
                    <article>
                      How We Helped Constructive Built Environment Build the
                      CART Platform
                    </article>
                  </div>
                </Link> */}
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className="ourwork-row-14 blog-row-14">
        <h2>Get in touch</h2>
        <p>
          Reach out to us to gather more information or{" "}
          <br className="blog-row-14-break" /> set our wheels in motion.
        </p>
        <div className="ourwork-arrow-box blog-arrow-box">
          <img src={Arrow} alt="arrow" className="ourwork-arrow" />
          <button onClick={() => navigate("/contactus")}>Let's talk</button>
        </div>
      </section>

      {!isTablet ? (
        <section className="home-footer">
          <div className="home-footer-middle">
            <img src={Amalgam} alt="Amalgam" className="home-footer-amalgam" />
            <Link to="/" className="home-footer-links">
              Home
            </Link>
            <Link to="/ourwork" className="home-footer-links">
              Our Work
            </Link>
            <Link to="/aboutus" className="home-footer-links">
              About Us
            </Link>
            <Link to="/case-studies" className="home-footer-links">
              Case Studies
            </Link>
            <Link to="/startups" className="home-footer-links">
              Launchpad
            </Link>
            <Link to="/careers" className="home-footer-links">
              Careers
            </Link>
            <Link to="/contactus" className="home-footer-links">
              Contact Us
            </Link>
            <img
              src={LinkedIn}
              alt="Instagram"
              className="home-footer-linkedin"
            />
          </div>
          <div className="home-footer-dividor">
            <div className="home-footer-policies">
              <p>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </p>
              <p>
                <Link to="/terms-and-conditions">Terms and Conditions</Link>
              </p>
              <p>
                <Link to="/cookie-policy">Cookie Policy</Link>
              </p>
            </div>
          </div>
        </section>
      ) : (
        <section>
          <div className="footer-minimal">
            <div className="footer-content">
              {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
                <img src={Amalgam} alt="Amalgam" className="footer-logo" />
                <img src={LinkedIn} alt="Instagram" className='home-footer-linkedin' style={{ alignSelf: "center" }} />
              </div> */}
              <div className="footer-top-row">
                <Link to="/" className="footer-link">
                  Home
                </Link>
                <span className="footer-separator">•</span>
                <Link to="/ourwork" className="footer-link">
                  Our Work
                </Link>
                <span className="footer-separator">•</span>
                <Link to="/aboutus" className="footer-link">
                  About Us
                </Link>
                <span className="footer-separator">•</span>
                <Link to="/case-studies" className="footer-link">
                  Case Studies
                </Link>
              </div>
              <div className="footer-bottom-row">
                <Link to="/startups" className="footer-link">
                  Launchpad
                </Link>
                <span className="footer-separator">•</span>
                <Link to="/careers" className="footer-link">
                  Careers
                </Link>
                <span className="footer-separator">•</span>
                <Link to="/contactus" className="footer-link">
                  Contact
                </Link>
              </div>
            </div>
          </div>

          <div
            style={{
              width: "80%",
              height: "0px",
              borderTop: "1px solid black",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingBottom: "20px",
              margin: "0 auto",
            }}
          ></div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "white",
              gap: isMobile ? "5px" : "20px",
              paddingBottom: "20px",
              width: "100%",
              padding: "0 10px 20px 10px",
              textAlign: "center",
            }}
          >
            <Link
              to="/privacy-policy"
              style={{
                textAlign: "center",
                color: "black",
                textDecoration: "none",
              }}
            >
              Privacy Policy
            </Link>
            <span style={{ color: "black", fontSize: "14px" }}>|</span>
            <Link
              to="/terms-and-conditions"
              style={{ color: "black", textDecoration: "none" }}
            >
              Terms and Conditions
            </Link>
            <span style={{ color: "black", fontSize: "14px" }}>|</span>
            <Link
              to="/cookie-policy"
              style={{
                fontSize: "14px",
                color: "black",
                textDecoration: "none",
              }}
            >
              Cookie Policy
            </Link>
          </div>
        </section>
      )}
    </div>
  );
}

export default Blog;
